import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

//
// Copyright IBM Corp. 2020, 2020
//
// This source code is licensed under the Apache-2.0 license found in the
// LICENSE file in the root directory of this source tree.
//
import React from 'react';
import PropTypes from 'prop-types';
import { idePrefix } from '../../globals/js/settings';

var IdeCreateStep = /*#__PURE__*/function (_React$Component) {
  _inherits(IdeCreateStep, _React$Component);

  var _super = _createSuper(IdeCreateStep);

  function IdeCreateStep() {
    _classCallCheck(this, IdeCreateStep);

    return _super.apply(this, arguments);
  }

  _createClass(IdeCreateStep, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(idePrefix, "-create-step")
      }, this.props.children);
    }
  }]);

  return IdeCreateStep;
}(React.Component);

_defineProperty(IdeCreateStep, "propTypes", {
  /**
   * Child components
   */
  children: PropTypes.any,

  /**
   * Label to show for the step (must NOT be set for pre-check step)
   */
  label: PropTypes.string
});

export default IdeCreateStep;